import { Block } from 'bitcoinjs-lib';
import { BlockNotFoundError } from '../errors/block.js';
export async function getBlock(client, { blockHash, blockNumber }) {
    let blockHex;
    try {
        let _blockHash = blockHash;
        if (!_blockHash && blockNumber) {
            _blockHash = await client.request({
                method: 'getblockhash',
                params: [blockNumber],
            }, { dedupe: true });
        }
        if (_blockHash) {
            blockHex = await client.request({
                method: 'getblock',
                params: [_blockHash, 0],
            }, { dedupe: true });
        }
    }
    catch (_error) {
        throw new BlockNotFoundError({ blockHash, blockNumber });
    }
    if (!blockHex) {
        throw new BlockNotFoundError({ blockHash, blockNumber });
    }
    return Block.fromHex(blockHex);
}
//# sourceMappingURL=getBlock.js.map